import { useAuth } from "@clerk/nextjs";
import { useMutation } from "@tanstack/react-query";
import { downloadUploadedPaper } from "helpers/api";

/**
 * Hook to download an Uploaded Paper
 */
export const useDownloadUploadedPaper = () => {
  const { getToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async (paperId: string) => {
      const token = await getToken();
      const blob = await downloadUploadedPaper(paperId, {
        authToken: token || undefined,
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `paper_${paperId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      return true;
    },
  });

  return {
    downloadPaper: mutation.mutateAsync,
    isDownloading: mutation.isLoading,
    error: mutation.error,
  };
};

export default useDownloadUploadedPaper;
